<ng-content select="app-page-header"></ng-content>
<ng-content select="app-page-body"></ng-content>
<ng-content select="app-page-footer"></ng-content>
<ng-content></ng-content>